import * as React from 'react';

import { cn } from '../../lib/cn';

/** The console's search input: raised grey, hairline border, 8px radius. */
export const SearchField = React.forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="search"
    className={cn(
      'h-9 w-full rounded-[8px] border border-dusq-line bg-dusq-raised px-4',
      'font-dusq text-[12px] text-dusq-text outline-none',
      'placeholder:text-dusq-grey600 focus:border-dusq-accent/60',
      className
    )}
    {...props}
  />
));
SearchField.displayName = 'SearchField';
